import { useQuery } from '@tanstack/react-query'
import { getProductAssets, type GetProductAssetsResponse } from '../api'
import { AxiosError } from 'axios'

export { useCreateProductForm } from './createProductForm'
export type { CreateProductFormData } from './createProductForm'

// Хук для получения ассетов продукта
export const useProductAssets = (orgId?: string, productId?: string) => {
    const { data, isLoading, error } = useQuery<GetProductAssetsResponse, AxiosError>({
        queryKey: ['product-assets', orgId, productId],
        queryFn: () => {
            if (!orgId || !productId) {
                throw new Error('orgId и productId обязательны')
            }
            return getProductAssets(orgId, productId)
        },
        enabled: !!orgId && !!productId,
    })

    return { data, isLoading, error }
}
